import React, { useContext } from 'react'
import HeaderWithSelect from 'app/react/components/HeaderWithSelect'
import IconsContext from 'app/react/components/icons/IconsContext'
import Files from 'app/react/components/icons/Files'
import useHoverContent from 'app/react/hooks/useHoverContent'

export default function IconsContent () {

  const { headerTitle, headerText, image, imageTitle, imageText, buttonTexts, files } = useContext(IconsContext)

  const { hoverClass, hoverContent } = useHoverContent({
    url: image ? image.url : '',
    copyText: buttonTexts.copy,
    downloadText: buttonTexts.download
  })

  return (
    <section id="icons" className="dm-icons">
      <div className="dm-icons__inner dm-page-container">
        <HeaderWithSelect
          title={headerTitle}
          text={headerText}
          noBorder
        />
        <div className="dm-image-text">
          {(image && image.url) && (
            <div className={'dm-image-text__image-container ' + hoverClass}>
              <img src={image.url} alt={image.alt}/>
              {hoverContent()}
            </div>
          )}
          <div className="dm-image-text__text-container">
            {imageTitle && (
              <h3 className="dm-image-text__title dm-title">{imageTitle}</h3>
            )}
            {imageText && (
              <div className="dm-image-text__text dm-wysiwyg dm-wysiwyg--fs14">{imageText}</div>
            )}
            <Files files={files} />
          </div>
        </div>
      </div>
    </section>
  )
}